<template>
    <div class="nav-wrap">
        <!-- 移动端汉堡菜单按钮 -->
        <div class="mobile-menu-btn" @click="toggleMobileMenu">
            <span :class="{ 'open': showMobileMenu }"></span>
            <span :class="{ 'open': showMobileMenu }"></span>
            <span :class="{ 'open': showMobileMenu }"></span>
        </div>

        <!-- 桌面端导航 -->
        <ul class="desktop-nav">
            <li class="top-logo" v-if="windowWidth > 1046"><img style="cursor: pointer;height: 35px;" @click="goHome()"
                    src="../NavWrap/images/logo.png" alt="">
            </li>
            <li @click="goHome()">首页</li>
            <li class="has-dropdown" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
                专题文献库
                <!-- 全屏下拉菜单 -->
                <div v-show="showDropdown" class="fullscreen-dropdown">
                    <div class="dropdown-content dropdown-content-8col">
                        <!-- 8列纵向排列 -->
                        <div class="dropdown-column" v-for="(group, groupIndex) in leftNavData" :key="groupIndex">
                            <h3 class="column-title" v-for="item in group" :key="item.uid"
                                @click="handleNavClick(item)">
                                <span class="title-text">{{ item.text }}</span>
                                <img src="./NEWIcon.png" alt="NEW" class="new-icon" v-if="item.shownew">
                            </h3>
                        </div>
                    </div>
                </div>
            </li>
            <li @click="goIap" style="position: relative;">课程思政案例库 <img src="./NewGift.gif"
                    style="position: absolute;top:14px;right: -4px;"></li>
            <li @click="goReport(); showMobileMenu = false" @mouseenter="showDropdown3 = true"
                @mouseleave="showDropdown3 = false">
                研究报告库
                <div v-show="showDropdown3" class="fullscreen-dropdown report-dropdown">
                    <div class="navTables">
                        <!-- 遍历报告分类 -->
                        <template v-for="(item, index) in expandedReportItems">

                            <!-- 
            过滤逻辑：
            1. item.isnav 必须为真。
            2. item.uid !== 'A10711'：跳过 A10711 的独立渲染，因为它将被合并到 A10712 中。
        -->
                            <div :key="item.uid" v-if="item.isnav && item.uid !== 'A10711'" class="tablecol" :class="{
                                'split-column': index === 7,
                                'double-col-item': item.uid === 'A10707',
                                'merged-last-col': item.uid === 'A10712' // 标记这是最后一列合并项
                            }">
                                <!-- 情况1：普通列 (非索引7) -->
                                <template v-if="index !== 7">
                                    <a :href="item.url || 'javascript:void(0);'" target="_blank" class="tablecolA"
                                        @click.prevent="handleReportNavClick(item)">
                                        {{ item.text }}
                                        <img v-if="item.shownew" src="./NEWIcon.png" alt="NEW" class="new-icon">
                                    </a>

                                    <!-- 垂直排列的子项列表 -->
                                    <ul class="tablerows" :class="{ 'grid-2-cols': item.uid === 'A10707' }">
                                        <!-- 1. 渲染当前项 (例如 A10712) 的子项 -->
                                        <li class="tablerow" v-for="(item2, index2) in item.children" :key="index2">
                                            <a :href="item2.url || 'javascript:void(0);'" target="_blank"
                                                class="tablerowA" @click.prevent="handleReportNavClick(item2)">
                                                {{ item2.text }}
                                                <img v-if="item2.shownew" src="./NEWIcon.png" alt="NEW"
                                                    class="new-icon">
                                            </a>
                                        </li>

                                        <!-- 2. 【关键】如果当前是 A10712，则紧接着渲染 A10711 的子项 -->
                                        <template v-if="item.uid === 'A10712'">
                                            <!-- 获取 A10711 的数据并渲染其标题和子项 -->
                                            <template v-for="mergedItem in getMergedItem('A10711')">
                                                <!-- 渲染合并项的标题 -->
                                                <li class="tablerow merged-title-row" :key="mergedItem.uid">
                                                    <a :href="mergedItem.url || 'javascript:void(0);'" target="_blank"
                                                        class="tablecolA merged-title"
                                                        style="margin-top: 10px; margin-bottom: 5px;">
                                                        {{ mergedItem.text }}
                                                        <img v-if="mergedItem.shownew" src="./NEWIcon.png" alt="NEW"
                                                            class="new-icon">
                                                    </a>
                                                </li>
                                                <!-- 渲染合并项的子项 -->
                                                <li class="tablerow" v-for="(subItem, subIndex) in mergedItem.children"
                                                    :key="subIndex">
                                                    <a :href="subItem.url || 'javascript:void(0);'" target="_blank"
                                                        class="tablerowA"
                                                        @click.prevent="handleReportNavClick(subItem)">
                                                        {{ subItem.text }}
                                                        <img v-if="subItem.shownew" src="./NEWIcon.png" alt="NEW"
                                                            class="new-icon">
                                                    </a>
                                                </li>
                                            </template>
                                        </template>
                                    </ul>
                                </template>

                                <!-- 情况2：特殊列 (索引 7) - 保持不变 -->
                                <template v-else>
                                    <div class="split-part">
                                        <a :href="item.url || 'javascript:void(0);'" target="_blank" class="tablecolA"
                                            @click.prevent="handleReportNavClick(item)">
                                            {{ item.text }}
                                            <img v-if="item.shownew" src="./NEWIcon.png" alt="NEW" class="new-icon">
                                        </a>
                                        <ul class="tablerows">
                                            <li class="tablerow" v-for="(item2, index2) in item.children" :key="index2">
                                                <a :href="item2.url || 'javascript:void(0);'" target="_blank"
                                                    class="tablerowA" @click.prevent="handleReportNavClick(item2)">
                                                    {{ item2.text }}
                                                    <img v-if="item2.shownew" src="./NEWIcon.png" alt="NEW"
                                                        class="new-icon">
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    <!-- 图解报告部分 (硬编码部分保持不变) -->
                                    <div class="split-part">
                                        <a href="javascript:void(0);" class="tablecolA">图解报告</a>
                                        <ul class="tablerows">
                                            <li class="tablerow">
                                                <a href="https://www.drcnet.com.cn/tradeReport?uid=A1020110"
                                                    target="_blank" class="tablerowA">中美贸易专报</a>
                                            </li>
                                            <li class="tablerow">
                                                <a href="http://zgjjbg.drcnet.com.cn" target="_blank"
                                                    class="tablerowA">中国经济形势全景图</a>
                                            </li>
                                        </ul>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </div>
                </div>
            </li>
            <li @click="goData()" @mouseenter="showDropdown2 = true" @mouseleave="showDropdown2 = false">
                国研数据
                <!-- 全屏下拉菜单 -->
                <div v-show="showDropdown2" class="fullscreen-dropdown statistical-dropdown">
                    <div class="dropdown-content dropdown-content-stat">
                        <div class="dropdown-column" v-for="(item, index) in leftNavData2" :key="item.uid"
                            v-if="item.isnav">
                            <h3 class="column-title statistical-sub-title">
                                {{ item.text }}
                            </h3>
                            <div class="statistical-sub" @click="handleNavClick(itemSub)"
                                v-for="itemSub, indexSub in item.children">
                                {{ itemSub.text }}
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li @click="goExperts()">专家库</li>
            <li @click="goHelp()">个性化服务</li>
        </ul>

        <!-- 移动端侧边抽屉菜单 -->
        <div class="mobile-drawer" :class="{ 'open': showMobileMenu }">
            <div class="mobile-drawer-header">
                <!-- <span>菜单</span> -->
                <!-- <span class="close-btn" @click="showMobileMenu = false">✕</span> -->

            </div>
            <loginComponent></loginComponent>
            <ul class="mobile-nav-list">

                <li @click="goHome(); showMobileMenu = false">首页</li>
                <li class="mobile-has-dropdown">
                    <div class="mobile-dropdown-toggle" @click="toggleMobileSubmenu">
                        <span>专题文献库</span>
                        <span class="mobile-arrow" :class="{ 'rotate': showMobileSubmenu }">▼</span>
                    </div>
                    <ul v-show="showMobileSubmenu" class="mobile-submenu">
                        <!-- {{ leftNavData }} -->
                        <li v-for="(item, index) in leftNavDataFlat" :key="item.uid" v-if="item.isnav"
                            @click="handleNavClick(item); showMobileMenu = false">
                            {{ item.text }}
                        </li>
                    </ul>
                </li>
                <li @click="goIap(); showMobileMenu = false">课程思政案例库</li>
                <li class="mobile-has-dropdown">
                    <!-- 一级标题：国研数据 -->
                    <div class="mobile-dropdown-toggle" @click="toggleMobileSubmenu3()">
                        <span>研究报告库</span>
                        <span class="mobile-arrow" :class="{ 'rotate': showMobileSubmenu3 }">▼</span>
                    </div>

                    <!-- 二级菜单列表 -->
                    <ul v-show="showMobileSubmenu3" class="mobile-submenu">
                        <li v-for="(item, index) in expandedReportItems" :key="item.uid" v-if="item.isnav">
                            <!-- 二级标题：可点击展开/收起三级菜单 -->
                            <div class="mobile-dropdown-toggle" @click.stop="toggleStatisticalItem(item.uid)">
                                <span>{{ item.text }}</span>
                                <!-- 根据当前 item 是否展开来旋转箭头 -->
                                <span class="mobile-arrow"
                                    :class="{ 'rotate': isStatisticalItemExpanded(item.uid) }">▼</span>
                            </div>

                            <!-- 三级菜单列表 -->
                            <ul v-show="isStatisticalItemExpanded(item.uid)" class="mobile-submenu-3">
                                <li v-for="(item2, index2) in item.children" :key="item2.uid" v-if="item2.isnav"
                                    @click="handleNavClick(item2)">
                                    {{ item2.text }}
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <!-- <li @click="goData(); showMobileMenu = false">国研数据</li> -->
                <li class="mobile-has-dropdown">
                    <!-- 一级标题：国研数据 -->
                    <div class="mobile-dropdown-toggle" @click="toggleMobileSubmenu2">
                        <span>国研数据</span>
                        <span class="mobile-arrow" :class="{ 'rotate': showMobileSubmenu2 }">▼</span>
                    </div>

                    <!-- 二级菜单列表 -->
                    <ul v-show="showMobileSubmenu2" class="mobile-submenu">
                        <li v-for="(item, index) in leftNavData2" :key="item.uid" v-if="item.isnav">
                            <!-- 二级标题：可点击展开/收起三级菜单 -->
                            <div class="mobile-dropdown-toggle" @click.stop="toggleStatisticalItem(item.uid)">
                                <span>{{ item.text }}</span>
                                <!-- 根据当前 item 是否展开来旋转箭头 -->
                                <span class="mobile-arrow"
                                    :class="{ 'rotate': isStatisticalItemExpanded(item.uid) }">▼</span>
                            </div>

                            <!-- 三级菜单列表 -->
                            <ul v-show="isStatisticalItemExpanded(item.uid)" class="mobile-submenu-3">
                                <li v-for="(item2, index2) in item.children" :key="item2.uid" v-if="item2.isnav"
                                    @click="handleNavClick(item2)">
                                    {{ item2.text }}
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li @click="goExperts(); showMobileMenu = false">专家库</li>
                <li @click="goHelp(); showMobileMenu = false">个性化服务</li>
            </ul>
        </div>

        <!-- 移动端遮罩层 -->
        <div class="mobile-overlay" v-show="showMobileMenu" @click="showMobileMenu = false"></div>
    </div>
</template>

<script>
import { getNav } from "../../api/home.js"
import { getLeftNav } from "../../api/special.js"
import loginComponent from "@/components/LoginMinx/index.vue"
import axios from "axios";
export default {
    components: {
        loginComponent
    },
    data() {
        return {
            leftNavData: [],
            leftNavData2: [],
            leftNavDataFlat: [],    // 一维数组，移动端用
            showDropdown: false,
            showDropdown2: false,
            showDropdown3: false,
            // 移动端新增状态
            showMobileMenu: false,
            showMobileSubmenu: false,
            showMobileSubmenu2: false,
            showMobileSubmenu3: false,
            // 用于记录国研数据下哪些二级菜单是展开的 (存储 uid)
            expandedStatisticalItems: [],
            // 用于记录研究报告库下的二级菜单
            expandedReportItems: []
        }
    },
    created() {
        this.fetchLeftNavData();
        this.getA107Nav()
    },
    mounted() {
        this.$eventBus.$on("ZTWX", (data) => {
            this.showDropdown = data
        });
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        getMergedItem(targetUid) {
            const targetItem = this.expandedReportItems.find(item => item.uid === targetUid);
            if (!targetItem) {
                return [];
            }
            // 返回一个数组，方便 v-for 遍历（虽然通常只有一个）
            return [targetItem];
        },
        handleScroll() {
            this.showDropdown = false;
            this.showDropdown2 = false;
        },
        goHelp() {
            window.open("https://www.drcnet.com.cn/customHelp", "_blank")
        },
        goExperts() {
            window.open("https://expert.drcnet.com.cn/#/home", "_blank")
        },
        goData() {
            window.open("https://data.drcnet.com.cn/home", "_blank")
        },
        goHome() {
            if (this.$route.path !== '/') {
                this.$router.push('/')
            }
        },
        goIap() {
            if (this.$route.path != "/iap") {
                this.$router.push({ path: '/iap', query: { uid: 'A206', title: '课程思政案例库' } })
            }
        },
        goReport() {
            window.open("https://report.drcnet.com.cn/", "_blank")
        },
        // 获取专题文献库数据
        // async fetchLeftNavData() {
        //     try {
        //         const response = await getNav({ version: 'A2' });
        //         if (response && response.data && response.data.data) {
        //             const rawData = response.data.data.find(item => item.uid === 'A201');
        //             if (rawData && rawData.children && Array.isArray(rawData.children)) {
        //                 this.leftNavData = rawData.children;
        //             } else {
        //                 this.leftNavData = [];
        //             }

        //             const rawData2 = response.data.data.find(item => item.uid === 'A203');
        //             if (rawData2 && rawData2.children && Array.isArray(rawData2.children)) {
        //                 this.leftNavData2 = rawData2.children;
        //             } else {
        //                 this.leftNavData2 = [];
        //             }
        //         }
        //     } catch (error) {
        //         console.error("获取左侧导航数据失败:", error);
        //         this.leftNavData = [];
        //     }
        // },
        // async fetchLeftNavData() {
        //     try {
        //         const response = await getLeftNav({ uid: 'A2' });
        //         if (response && response.data && response.data.data) {

        //             const rawData = response.data.data.data.children.find(item => item.uid === 'A201');

        //             if (rawData && rawData.children && Array.isArray(rawData.children)) {

        //                 this.leftNavData = rawData.children;

        //             } else {
        //                 this.leftNavData = [];
        //             }

        //             const rawData2 = response.data.data.data.children.find(item => item.uid === 'A203');
        //             if (rawData2 && rawData2.children && Array.isArray(rawData2.children)) {
        //                 this.leftNavData2 = rawData2.children;
        //             } else {
        //                 this.leftNavData2 = [];
        //             }
        //         }
        //     } catch (error) {
        //         console.error("获取左侧导航数据失败:", error);
        //         this.leftNavData = [];
        //     }
        // },
        async fetchLeftNavData() {
            try {
                const response = await getLeftNav({ uid: 'A2' });
                if (response && response.data && response.data.data) {
                    const rawData = response.data.data.data.children.find(item => item.uid === 'A201');

                    if (rawData && rawData.children && Array.isArray(rawData.children)) {
                        const allItems = rawData.children.filter(item => item.isnav);
                        this.leftNavDataFlat = allItems;  // 移动端用

                        // 分组逻辑...
                        this.leftNavData = groupedData;   // 桌面端用

                        // 纵向8列分组：前5列每列6个，后3列每列5个
                        const groupSizes = [6, 6, 6, 6, 6, 5, 5, 5];
                        const groupedData = [];
                        let currentIndex = 0;

                        groupSizes.forEach(size => {
                            groupedData.push(allItems.slice(currentIndex, currentIndex + size));
                            currentIndex += size;
                        });

                        this.leftNavData = groupedData;
                    } else {
                        this.leftNavData = [];
                    }

                    const rawData2 = response.data.data.data.children.find(item => item.uid === 'A203');
                    if (rawData2 && rawData2.children && Array.isArray(rawData2.children)) {
                        this.leftNavData2 = rawData2.children;
                    } else {
                        this.leftNavData2 = [];
                    }
                }
            } catch (error) {
                console.error("获取左侧导航数据失败:", error);
                this.leftNavData = [];
            }
        },
        // 处理导航项点击
        handleNavClick(item) {
            if (item.url != '' && item.url != '/list') {

                window.open(item.url, '_blank');
                this.showDropdown = false;
            } else {

                this.$router.push({
                    path: '/list',
                    query: { uid: item.uid, title: item.text }
                });
                this.showDropdown = false;
            }
        },
        handleReportNavClick(item) {
            // 如果 item 有 url 且不是 javascript:void(0)，则允许默认行为或手动打开
            if (item.url && item.url !== 'javascript:void(0);') {
                window.open(item.url, '_blank');
            } else if (item.uid) {
                // 如果没有 url 但有 uid，可能需要进行路由跳转或其他逻辑
                this.$router.push({
                    path: '/list',
                    query: { uid: item.uid, title: item.text }
                });
            }
            this.showDropdown3 = false;
        },


        // 移动端新增方法
        toggleMobileMenu() {
            this.showMobileMenu = !this.showMobileMenu;
            // 打开菜单时禁止背景滚动
            if (this.showMobileMenu) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
                this.showMobileSubmenu = false;
            }
        },
        toggleStatisticalItem(uid) {
            const index = this.expandedStatisticalItems.indexOf(uid);
            if (index > -1) {
                // 如果已展开，则收起
                this.expandedStatisticalItems.splice(index, 1);
            } else {
                // 如果未展开，则展开
                this.expandedStatisticalItems.push(uid);
            }
        },
        isStatisticalItemExpanded(uid) {
            return this.expandedStatisticalItems.includes(uid);
        },

        toggleMobileSubmenu() {
            this.showMobileSubmenu = !this.showMobileSubmenu;
        },
        toggleMobileSubmenu2() {
            this.showMobileSubmenu2 = !this.showMobileSubmenu2;
        },
        toggleMobileSubmenu3() {
            this.showMobileSubmenu3 = !this.showMobileSubmenu3;
        },
        async getA107Nav() {
            const response = await axios.get(`${process.env.VUE_APP_BASE_API}/WebChannelCommonController/getAllSonMenus?uid=A107`);
            console.log('responseresponseresponseresponse', response.data.data.data.children);
            if (response.data.code == 0 && response.data && response.data.data) {
                this.expandedReportItems = response.data.data.data.children;
                console.log('this.expandedReportItemsthis.expandedReportItemsthis.expandedReportItems', this.expandedReportItems);
            }
        }
    }
}
</script>

<style lang="less" scoped>
.nav-wrap {
    // height: 73px;
    height: 64px;
    background: #175B9A;
    position: relative;

    .desktop-nav {
        display: flex;
        list-style: none;
        padding: 0 30px;
        justify-content: flex-start;
        align-items: center;
        height: 100%;
        margin: 0;

        li {
            color: white;
            cursor: pointer;
            font-weight: bold;
            font-size: 18px;
            position: relative;

            &:not(:first-child) {
                padding: 0 16px;
                line-height: 64px;
            }

            &:first-child {
                margin-right: 20px;

            }

            // &:not(:first-child)::before {
            //     content: "|";
            //     font-weight: 100;
            //     margin-right: 8px;
            //     margin-left: 8px;
            //     color: #8facc7;
            // }

            // &::after {
            //     content: "";
            //     position: absolute;
            //     bottom: -35px;
            //     left: 0;
            //     width: 100%;
            //     height: 35px;
            //     background: none;
            // }
        }

        .has-dropdown {
            &:hover {
                color: #90caf9;
            }
        }
    }
}

// 全屏下拉菜单
.fullscreen-dropdown {
    position: fixed;
    // top: 112px;
    top: 86px;
    left: 0;
    width: 100vw;
    background: #ffffff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    z-index: 9999;
    padding: 30px 0;
    animation: slideDown 0.3s ease;
    max-height: 70vh;
    overflow-y: auto;


    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
}

.dropdown-content {
    width: 1500px;
    margin: 0 auto;
    padding: 0 60px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

}

.dropdown-content-stat {
    justify-content: center;
    gap: 20px;

    &:first-child {
        padding-left: 10%
    }

    .dropdown-column {
        flex: 0 0 calc(30% - 16px);
    }
}

.dropdown-column {
    flex: 0 0 calc(20% - 16px);
    // margin-bottom: 15px;

    .column-title {
        color: #333;
        // color: #175B9A;
        font-size: 16px;
        font-weight: normal;
        margin: 0;
        cursor: pointer;
        border-radius: 4px;
        transition: all 0.2s;
        display: inline-flex;
        align-items: center;
        justify-content: flex-start;
        // display: flex;
        // align-items: center;
        // justify-content: space-between;

        &:hover {
            background-color: #f0f7ff;
            color: #0d47a1;
        }

        // .title-text {
        //     // 确保文字不会挤压图片
        //     white-space: nowrap; 
        //     overflow: hidden;
        //     text-overflow: ellipsis;
        //     max-width: 90%; // 给图片留点空间
        // }
        .new-icon {
            display: inline-block; // 确保是行内块
            width: auto; // 保持图片原始比例或指定固定小尺寸
            height: 16px; // 根据实际图标大小调整，通常比字体稍小或相等
            margin-left: 4px; // 图片和文字之间的微小间距
            vertical-align: middle; // 垂直居中对齐

            // 如果图片本身很大，需要限制大小
            // max-width: 30px;
        }
    }

    .statistical-sub-title {
        color: #175B9A;
        font-size: 20px;
        font-weight: bold;
        margin: 0;
        cursor: pointer;
        border-radius: 4px;
        transition: all 0.2s;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 24px;
    }

    .statistical-sub {
        color: #333;
        font-size: 16px;
        font-weight: normal;
        margin: 0;
        cursor: pointer;
        border-radius: 4px;
        transition: all 0.2s;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;

    }
}

// ==================== 移动端新增样式 ====================
// 汉堡菜单按钮（默认隐藏）
.mobile-menu-btn {
    display: none;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 24px;
    cursor: pointer;
    z-index: 10001;

    span {
        display: block;
        width: 100%;
        height: 3px;
        background: #fff;
        margin-bottom: 6px;
        transition: all 0.3s ease;
        border-radius: 2px;

        &:last-child {
            margin-bottom: 0;
        }

        &.open {
            &:nth-child(1) {
                transform: rotate(45deg) translate(6px, 6px);
            }

            &:nth-child(2) {
                opacity: 0;
            }

            &:nth-child(3) {
                transform: rotate(-45deg) translate(7px, -7px);
            }
        }
    }
}

// 移动端抽屉菜单（默认隐藏）
.mobile-drawer {
    display: none;
    position: fixed;
    top: 0;
    right: -280px;
    width: 280px;
    height: 100vh;
    background: #175B9A;
    z-index: 10000;
    transition: right 0.3s ease;
    overflow-y: auto;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);

    &.open {
        right: 0;
    }

    .mobile-drawer-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        // border-bottom: 1px solid rgba(255, 255, 255, 0.2);

        .close-btn {
            cursor: pointer;
            font-size: 20px;
            padding: 0 5px;
        }
    }

    .mobile-nav-list {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
            color: #fff;
            font-size: 16px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);

            &:active {
                background: rgba(255, 255, 255, 0.1);
            }
        }

        // 普通菜单项
        >li:not(.mobile-has-dropdown) {
            padding: 15px 20px;
            cursor: pointer;
        }

        // 下拉菜单项
        .mobile-has-dropdown {
            .mobile-dropdown-toggle {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 15px 20px;
                cursor: pointer;

                .mobile-arrow {
                    font-size: 12px;
                    transition: transform 0.3s ease;
                    color: rgba(255, 255, 255, 0.7);

                    &.rotate {
                        transform: rotate(180deg);
                    }
                }
            }

            .mobile-submenu-3 {
                list-style: none;
                padding: 0;
                margin: 0;
                // background: rgba(0, 0, 0, 0.2);

                li {
                    padding: 12px 20px 12px 35px;
                    font-size: 14px;
                    color: rgba(255, 255, 255, 0.9);
                    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
                    cursor: pointer;

                    &:active {
                        background: rgba(255, 255, 255, 0.1);
                    }
                }
            }

            .mobile-submenu {
                list-style: none;
                padding: 0;
                margin: 0;
                background: rgba(0, 0, 0, 0.2);

                li {
                    padding: 12px 20px 12px 35px;
                    font-size: 14px;
                    color: rgba(255, 255, 255, 0.9);
                    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
                    cursor: pointer;

                    &:active {
                        background: rgba(255, 255, 255, 0.1);
                    }
                }
            }
        }
    }
}

// 遮罩层
.mobile-overlay {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
}

.dropdown-content-8col {
    width: 1520px;
    margin: 0 auto;
    padding: 20px 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row; // 横向排列8列
    flex-wrap: nowrap; // 不换行
    gap: 16px;
    justify-content: center; // 居中
    align-items: flex-start; // 顶部对齐

    .dropdown-column {
        flex: 1; // 每列等宽
        min-width: 0;
        display: flex;
        flex-direction: column; // 列内纵向排列
        gap: 8px; // 列内项间距

        .column-title {
            color: #333;
            font-size: 16px;
            font-weight: normal;
            margin: 0;
            padding: 8px 12px;
            cursor: pointer;
            border-radius: 4px;
            transition: all 0.2s;
            white-space: normal;
            word-break: break-word;
            text-align: left;
            line-height: 1.5;

            &:nth-child(4n) {
                min-height: 33px;
                line-height: 1.2;
            }

            &:hover {
                background-color: #f0f7ff;
                color: #0d47a1;
            }
        }
    }
}

.report-dropdown {
    background: #ffffff;
    padding: 20px 0;

    .navTables {
        display: flex;
        // width: 1500px;
        margin: 0 auto;
        padding: 0 12%;
        justify-content: space-between;
        gap: 1%;
        align-items: flex-start;
    }

    .tablecol {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        // min-width: 160px;

        // 如果是 A10707，增加列宽以容纳两列内容
        &.double-col-item {
            width: 260px;
        }

        &.split-column {
            height: 100%;
            justify-content: space-between;

            .split-part {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                flex: 1;
                margin-bottom: 20px;

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }

    .tablecolA {
        font-size: 16px;
        font-weight: bold;
        color: #175B9A;
        text-decoration: none;
        margin-bottom: 8px;
        display: block;
        line-height: 1.4;
        transition: color 0.3s ease;
        white-space: nowrap; // 主标题不折行

        &:hover {
            color: #ffe400;
            text-decoration: none;
        }

        .new-icon {
            height: 16px;
            margin-left: 4px;
            vertical-align: middle;
        }
    }

    .tablerows {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column; // 默认单列
        gap: 6px;

        // 【关键修改】针对 A10707 的双列纵向布局
        &.grid-2-cols {
            display: block; // 重置 flex，改用 columns
            column-count: 2; // 分为两列
            column-gap: 24px; // 列间距
            width: 100%;
            // gap: 24px;

            .tablerow {
                break-inside: avoid; // 防止子项被切断到另一列
                margin-bottom: 6px; // 行间距
                width: 100%; // 确保占满列宽

                .tablerowA {
                    white-space: nowrap; // 强制不折行
                    overflow: visible; // 确保内容完全显示
                    text-overflow: clip; // 不使用省略号
                    display: block; // 确保链接块级显示
                }
            }
        }

        // 默认单列样式保持不变
        .tablerow {
            writing-mode: horizontal-tb;
            padding: 0 !important;

            .tablerowA {
                font-size: 15px;
                font-weight: normal;
                color: #333;
                text-decoration: none;
                display: block;
                line-height: 1.4;
                padding: 2px 0;
                transition: color 0.3s ease;
                white-space: nowrap;

                &:hover {
                    color: #ffe400;
                }

                .new-icon {
                    height: 14px;
                    margin-left: 4px;
                    vertical-align: middle;
                }
            }
        }
    }
}


@media screen and (min-width: 770px) and (max-width: 1500px) {
    .navTables{
        padding: 0 1% !important;
    }
    .nav-wrap {
        // min-width: 1074px;
        padding: 0 1%;
       
        .desktop-nav {
            padding: 0;

        }
    }

    .dropdown-content {
        width: 100% !important;
    }
    .dropdown-content-stat {
        padding: 0 !important;
        
    }
    .statistical-dropdown{
        .dropdown-content-stat{
            gap: 0 !important;
        }
        .dropdown-column:first-child{
            padding-left:6% !important;
           
        }
        .dropdown-column:last-child{
            padding-left: 6% !important;
        }
    }

}


// ==================== 响应式断点：小于等于 769px ====================
@media screen and (max-width: 769px) {
    .nav-wrap {
        .desktop-nav {
            display: none; // 隐藏桌面端导航
        }
    }

    ::v-deep.navigation-nav {
        float: none !important;
        position: absolute;
        right: 60px;
        top: 15px;

        li {
            list-style: none
        }
    }

    // 显示移动端元素
    .mobile-menu-btn {
        display: block;
    }

    .mobile-drawer {
        display: block;
    }

    .mobile-overlay {
        display: block;
    }

    // 桌面端下拉菜单在移动端隐藏
    .fullscreen-dropdown {
        display: none !important;
    }
}

// 响应式适配（原有）
@media screen and (max-width: 1200px) {
    .dropdown-column {
        flex: 0 0 calc(25% - 15px);
    }

}

// @media screen and (min-width: 770px) and (max-width: 1000px) {

//     .desktop-nav {
//         li {
//             &:not(:first-child)::before {
//                 margin-right: 19px !important;
//                 margin-left: 19px !important;
//             }
//         }
//     }
// }

@media screen and (max-width: 769px) {
    .dropdown-column {
        flex: 0 0 calc(50% - 10px);
    }

    .dropdown-content {
        padding: 0 20px;
    }
}
</style>